import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type ProfilePageStore } from 'pages/conversations/pages/search/pages/profile/store/profilePageStore'

export const ProfilePageContext = createContext<ProfilePageStore | null>(null)

export const useProfilePageContext = () => {
  const context = useContext(ProfilePageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ProfilePageContext')

  return context
}

type IProviderProfilePageProps = {
  value: ProfilePageStore
  children: ReactNode
}

export const ProviderProfilePage: FC<IProviderProfilePageProps> = ({ value, children }) => {
  return <ProfilePageContext.Provider value={value}>{children}</ProfilePageContext.Provider>
}
